import {constance} from '../constance/constance';

export let config = {
    maxWidth: 1150,
    style: {
        transition: 'all ease-out 0.3s',
        border: '1px solid #b8b8b8',
        borderColor: '#b8b8b8',
    },
    workplaceBoardList: ['department-meeting', 'club', 'event', 'bestFriends', 'share', 'menu', 'book-support', 'notice', 'all'],      // 글목록 화면에서 사업장 선택 노출 메뉴
    editorWorkplaceBoardList: ['department-meeting', 'club', 'event', 'bestFriends', 'share', 'menu', 'book-support', 'notice'],        // 글쓰기 화면에서 사업장 선택 노출 메뉴
    shareBoardList: ['share'],
    clubId: 'club',
    departmentId: 'department-meeting',
    menu: [
        {
            id: 'culture-forum',
            index: 0,
            name: '문화포럼',
            path: '/culture-forum/calendar',
            viewComment: false,
            allowAdminReply: false,
            allowAdminPost: false,
            showNotice: false,
            placeholder: '',
            usage: true,
            subMenu: [
                {
                    id: 'calendar',
                    name: '일정',
                    path: '/culture-forum/calendar',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: false,
                    usage: true,
                },
                {
                    id: 'replay',
                    name: '다시보기',
                    path: '/culture-forum/replay',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
                {
                    id: 'suggestedTopic',
                    name: '주제제안',
                    path: '/board?id=suggestedTopic&page=1&limit=10&keyword=&search-type=title',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: false,
                },
                {
                    id: 'afp',
                    name: '발표신청',
                    path: '/board?id=afp&page=1&limit=10&keyword=&search-type=title',
                    viewComment: true,
                    allowAdminReply: true,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '사업장 | 부서 | 이름',
                    usage: false,
                },
            ],
        },
        {
            id: 'small-group',
            index: 1,
            name: '소모임',
            path: `/board?id=department-meeting&workplace=${constance.workplace.ALL.value}&page=1&limit=10&keyword=&search-type=title`,
            viewComment: false,
            allowAdminReply: false,
            allowAdminPost: false,
            showNotice: true,
            usage: true,
            subMenu: [
                {
                    id: 'department-meeting',
                    name: '부서게시판',
                    path: `/board?id=department-meeting&workplace=${constance.workplace.ALL.value}&page=1&limit=10&keyword=&search-type=title`,
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
                {
                    id: 'club',
                    name: '동호회',
                    path: `/board?id=club&workplace=${constance.workplace.ALL.value}&page=1&limit=10&keyword=&search-type=title`,
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
                {
                    id: 'employeeAssociation',
                    name: '사우회',
                    path: `/board?id=employeeAssociation&workplace=${constance.workplace.ALL.value}&page=1&limit=10&keyword=&search-type=title`,
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
            ],
        },
        {
            id: 'communication',
            index: 2,
            name: '소통공간',
            path: '/board?id=free&page=1&limit=10&keyword=&search-type=title',
            viewComment: false,
            allowAdminReply: false,
            allowAdminPost: false,
            showNotice: true,
            usage: true,
            subMenu: [
                {
                    id: 'free',
                    name: '자유게시판',
                    path: '/board?id=free&page=1&limit=10&keyword=&search-type=title',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
                {
                    id: 'suggest',
                    name: '건의합니다',
                    path: '/board?id=suggest&page=1&limit=10&keyword=&search-type=title',
                    viewComment: false,
                    allowAdminReply: true,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
                {
                    id: 'event',
                    name: '사내소식',
                    path: `/board?id=event&workplace=${constance.workplace.ALL.value}&page=1&limit=10&keyword=&search-type=title`,
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
                {
                    id: 'bestFriends',
                    name: '베스트 프렌즈',
                    path: `/board?id=bestFriends&workplace=${constance.workplace.ALL.value}&page=1&limit=10&keyword=&search-type=title`,
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
                {
                    id: 'suninNews',
                    name: '선인의 추억',
                    path: `/board?id=suninNews&workplace=${constance.workplace.ALL.value}&page=1&limit=10&keyword=&search-type=title`,
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
            ],
        },
        {
            id: 'share',
            index: 3,
            name: '나눔공간',
            path: `/board?id=share&workplace=${constance.workplace.ALL.value}&keyword=&search-type=title`,
            viewComment: false,
            allowAdminReply: false,
            allowAdminPost: false,
            showNotice: true,
            usage: true,
            subMenu: [
                {
                    id: 'share',
                    name: '나눔',
                    path: `/board?id=share&workplace=${constance.workplace.ALL.value}&keyword=&search-type=title`,
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
                {
                    id: 'fleaMarket',
                    name: '플리마켓',
                    path: '/board?id=fleaMarket&page=1&limit=10&keyword=&search-type=title',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
            ],
        },
        {
            id: 'in-house-materials',
            index: 4,
            name: '사내자료',
            path: '/board?id=menu&page=1&limit=10&keyword=&search-type=title',
            viewComment: false,
            allowAdminReply: false,
            allowAdminPost: false,
            showNotice: true,
            usage: true,
            subMenu: [
                {
                    id: 'menu',
                    name: '식단표',
                    path: `/board?id=menu&workplace=${constance.workplace.ALL.value}&page=1&limit=10&keyword=&search-type=title`,
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: 'n주차 식단표입니다.',
                    subMenu: [],
                    usage: true,
                },
                {
                    id: 'retirementPensionEducation',
                    name: '퇴직연금 교육',
                    path: `/board?id=retirementPensionEducation&page=1&limit=10&keyword=&search-type=title`,
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    subMenu: [],
                    usage: true,
                },
                {
                    id: 'informationProtectionEducation',
                    name: '정보보호 교육',
                    path: `/board?id=informationProtectionEducation&page=1&limit=10&keyword=&search-type=title`,
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    subMenu: [],
                    usage: true,
                },
            ],
        },
        {
            id: 'book',
            index: 5,
            name: '도서지원',
            path: `/book?id=book-rental&workplace=${constance.workplace.ALL.value}&page=1&limit=10&keyword=&search-type=name`,
            viewComment: false,
            allowAdminReply: false,
            allowAdminPost: false,
            showNotice: true,
            placeholder: '',
            subMenu: [
                {
                    id: 'book-rental',
                    name: '도서대여',
                    path: '/book?workplace=0&page=1&limit=10&keyword=&search-type=name&keyword=&search-type=name',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
                {
                    id: 'book-application',
                    name: '도서신청',
                    path: '/book-application?page=1&limit=10&workspace=0',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '',
                    usage: true,
                },
                {
                    id: 'book-report',
                    name: '독후감',
                    path: `/board?id=book-report&workplace=${constance.workplace.ALL.value}&page=1&limit=10&keyword=&search-type=title`,
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    placeholder: '도서명 / 저자',
                    usage: true,
                },
            ],
            usage: true,
        },
        {
            id: 'notice',
            index: 6,
            name: '공지',
            path: `/board?id=notice&workplace=${constance.workplace.ALL.value}&keyword=&search-type=title`,
            viewComment: false,
            allowAdminReply: false,
            allowAdminPost: true,
            showNotice: false,
            placeholder: '',
            subMenu: [],
            usage: true,
        },
        {
            id: 'faq',
            index: 7,
            name: '자주 묻는 질문',
            path: `/board?id=faq&workplace=${constance.workplace.ALL.value}&keyword=&search-type=title`,
            viewComment: false,
            allowAdminReply: false,
            allowAdminPost: true,
            showNotice: false,
            placeholder: '',
            subMenu: [],
            usage: true,
        },
        {
            id: 'note-box',
            index: 8,
            name: '쪽지함',
            path: '/note-box/send-note',
            admin: true,
            viewComment: false,
            allowAdminReply: false,
            allowAdminPost: false,
            showNotice: false,
            placeholder: '',
            usage: false,
            subMenu: [
                {
                    id: 'send-note',
                    name: '쪽지보내기',
                    path: '/note-box/send-note',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    usage: false,
                    placeholder: '',
                },
                {
                    id: 'inbox',
                    name: '받은쪽지함',
                    path: '/note-box/inbox',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    usage: false,
                    placeholder: '',
                },
                {
                    id: 'sent-inbox',
                    name: '보낸쪽지함',
                    path: '/note-box/sent-inbox',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    usage: false,
                    placeholder: '',
                },
            ],
        },

        {
            id: 'all',
            index: 9,
            name: '전체',
            path: `/board?id=all&keyword=&search-type=title`,
            admin: false,
            viewComment: false,
            allowAdminReply: false,
            allowAdminPost: false,
            showNotice: true,
            placeholder: '',
            usage: true,
            subMenu: [],
        },


        {
            id: 'admin',
            index: 10,
            name: '관리자',
            path: '/admin/culture-forum/registration',
            admin: true,
            viewComment: false,
            allowAdminReply: false,
            allowAdminPost: false,
            showNotice: false,
            placeholder: '',
            usage: true,
            subMenu: [
                {
                    id: 'adminCalendar',
                    name: '일정 등록',
                    path: '/admin/culture-forum/calendar',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    usage: true,
                    placeholder: '',
                },
                {
                    id: 'adminCultureForumRegistration',
                    name: '문화포럼 등록',
                    path: '/admin/culture-forum/registration',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    usage: true,
                    placeholder: '',
                },
                {
                    id: 'adminClub',
                    name: '동호회 관리',
                    path: '/admin/club',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    usage: true,
                    placeholder: '',
                },
                {
                    id: 'adminBook',
                    name: '도서 관리',
                    path: '/admin/book',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    usage: true,
                    placeholder: '',
                },
                {
                    id: 'evaluator',
                    name: '평가자 관리',
                    path: '/admin/evaluator',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    usage: true,
                    placeholder: '',
                },
                {
                    id: 'flea-market',
                    name: '플리마켓 관리',
                    path: '/admin/flea-market',
                    viewComment: false,
                    allowAdminReply: false,
                    allowAdminPost: false,
                    showNotice: true,
                    usage: true,
                    placeholder: '',
                },
            ],
        },


    ],
    url: {
        board: '/board',
        book: '/book',
        bookApplication: '/book-application',
        postWrite: `/post-write`,
        postView: `/post-view`,
        postUpdate: `/post-update`,
        noteBox: '/note-box',
        attendance: '/attendance',
    },
    noteBox: {
        'send-note': {
            id: 'send-note',
            text: '쪽지보내기',
        },
        'inbox': {
            id: 'inbox',
            text: '받은쪽지함',
        },
        'sent-inbox': {
            id: 'sent-inbox',
            text: '보낸쪽지함',
        },
    },
    pathNameMap: {
        '/culture-forum/calendar': {step1: '문화포럼', step2: '일정'},
        '/culture-forum/replay': {step1: '문화포럼', step2: '다시보기'},
        '/board': {
            'suggestedTopic': {step1: '문화포럼', step2: '주제제안'},
            'afp': {step1: '문화포럼', step2: '발표신청'},
            'department-meeting': {step1: '소모임', step2: '부서게시판'},
            'club': {step1: '소모임', step2: '동호회'},
            'free': {step1: '소통공간', step2: '자유게시판'},
            'suggest': {step1: '소통공간', step2: '건의합니다'},
            'event': {step1: '소통공간', step2: '사내소식'},
            'bestFriends': {step1: '소통공간', step2: '베스트 프렌즈'},
            'suninNews': {step1: '소통공간', step2: '선인의 추억'},
            'employeeAssociation': {step1: '소통공간', step2: '사우회'},
            'share': {step1: '나눔공간', step2: '나눔'},
            'fleaMarket': {step1: '나눔공간', step2: '플리마켓'},
            'book-report': {step1: '도서지원', step2: '독후감'},
            'menu': {step1: '사내자료', step2: '식단표'},
            'retirementPensionEducation': {step1: '사내자료', step2: '퇴직연금 교육'},
            'informationProtectionEducation': {step1: '사내자료', step2: '정보보호 교육'},
            'notice': {step1: '공지', step2: ''},
            'faq': {step1: '자주 묻는 질문', step2: ''},
            'all': {step1: '전체', step2: ''},
        },
        '/book': {step1: '도서지원', step2: '도서대여'},
        '/book-application': {step1: '도서지원', step2: '도서신청'},
        '/book-report': {step1: '도서지원', step2: '독후감'},
        '/note-box/send-note': {step1: '쪽지함', step2: '쪽지보내기'},
        '/note-box/inbox': {step1: '쪽지함', step2: '받은쪽지함'},
        '/note-box/sent-inbox': {step1: '쪽지함', step2: '보낸쪽지함'},
        '/admin/culture-forum/calendar': {step1: '관리자', step2: '일정 등록'},
        '/admin/culture-forum/registration': {step1: '관리자', step2: '문화포럼 등록'},
        '/admin/club': {step1: '관리자', step2: '동호회 관리'},
        '/admin/book': {step1: '관리자', step2: '도서 관리'},
        '/admin/evaluator': {step1: '관리자', step2: '평가자 관리'},
        '/admin/flea-market': {step1: '관리자', step2: '플리마켓 관리'},
    },
    devPath: 'http://localhost:80',
    serverPath: 'https://forum.sib.kr',
};

